module.exports = __webpack_public_path__ + "static/media/print-logo-4.a0872312.png";